/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import { fieldsMixin }             from 'mixins';
  import TableAttributeFieldValue    from 'components/QueryResultsTableAttributeFieldValue.vue';
  import InfoFormats                 from 'components/QueryResultsActionInfoFormats.vue';
  import HeaderFeatureBody           from 'components/QueryResultsHeaderFeatureBody.vue';
  import HeaderFeatureActionsBody    from "components/QueryResultsHeaderFeatureActionsBody.vue";
  import { toRawType }               from 'utils/toRawType';
  import { throttle }                from 'utils/throttle';
  import { getCatalogLayerById }     from 'utils/getCatalogLayerById';
  import { getMapLayersByFilter }    from 'utils/getMapLayersByFilter';
  import { downloadFeatures }        from 'utils/downloadFeatures';
  import { showDownloadFormats }     from 'utils/downloadFeatures';
  import GUI                         from 'services/gui';
  
  const headerExpandActionCellWidth = 10;
  const headerActionsCellWidth      = 10;
  const HEADERTYPESFIELD            = [
    'varchar',
    'integer',
    'float',
    'bigint', //@since v3.9
    'date',
  ];

  const __vue_script__ = {

    /** @since 3.8.6 */
    name: 'queryresults',

    data() {
      return {
        state:                       this.$options.service.state,
        headerExpandActionCellWidth: headerExpandActionCellWidth,
        headerActionsCellWidth:      headerActionsCellWidth,
      }
    },
    mixins: [fieldsMixin],
    components: {
      TableAttributeFieldValue,
      'infoformats':         InfoFormats,
      'header-feature-body': HeaderFeatureBody,
      HeaderFeatureActionsBody
    },
    computed: {
      onelayerresult() {
        return 1 === this.state.layers.length;
      },
      hasLayers() {
        return this.hasResults || !!this.state.components.length;
      },
      hasResults() {
        return this.state.layers.length > 0;
      },

      /**
       * @typedef QueryResultsInfo
       * 
       * @property { string | null }     icon
       * @property { string | null }     message
       * @property { (() => {}) | null } action
       */
      /**
       * @returns {QueryResultsInfo} query info
       */
      info() {
        if (this.state.query) {
          const query         = this.state.query;
          //@since 3.8.1 coordinates show only four decimal numbers
          //In case of map units degrees, show four decimal numbers otherwise, meter, show only two decimal numbers
          const decimalNumber = 'degrees' === GUI.getService('map').getMapUnits() ? 4 : 2;
          switch (query.type) {
            case 'coordinates':
              return {
                icon:    'marker',
                message: `  ${query.coordinates[0].toFixed(decimalNumber)}, ${query.coordinates[1].toFixed(decimalNumber)}`
              };
            case 'bbox':
              return {
                icon:    'square',
                message: `  [${query.bbox.map(c => c.toFixed(decimalNumber)).join(' , ')}]`
              };
            case 'polygon':
            case 'drawpolygon':
              return {
                icon: 'draw',
                message: (query.layerName) ?
                  `${query.layerName} ${undefined !== query.fid ? ` - Feature Id: ${query.fid}` : ''}` // <Feature ID>:   when polygon feature comes from a Feature layer
                  : ' '                                                                                         // <empty string>: when polygon feature comes from a Drawed layer (temporary layer)
              };
              case 'circle':
                return {
                  icon: 'empty-circle',
                  message: ' ',                                                                                     // <empty string>: when polygon feature comes from a Drawed layer (temporary layer)
                };
            default:
              console.warn(`Unsupported query type:  ${query.type}`);
              break;
          }
        } else if (this.state.search) {
          /** @FIXME missing implementation? */
        }

        return { icon: null, message: null };

      },

      queryableLayers() {
        return getMapLayersByFilter({ QUERYABLE: true });
      },

      selectedLayer() {
        return GUI.getService('map').getSelectedLayer();
      },

    },
    methods: {

      /**
       * @returns { boolean } whether can paginate layer results
       */
      canPaginate(layer) {
        return !!(this.state.query && this.state.query.pagination && this.state.query.pagination.paginate[this.state.layers.findIndex(l => l == layer)]);
      },

      /**
       * @returns { boolean } whether can show "add to select" action
       */
      canSelect(layer) {
        return (
          GUI.getService('queryresults').getActionLayerById({ layer, id: 'selection' })
          && (!this.canPaginate(layer) || (layer.selection.active && layer.filter.active))
          && layer.features.length > 1
        );
      },

      /**
       * @since v3.10.0
       *
       * @param { Array.<string> } downloads
       *
       * return {Array} return array of download formats enable of layer features
       */
      getLayerDownloads(downloads = []) {
        return downloads.filter(d => 'pdf' !== d);
      },

      /**
       * @param { Object } layer
       * 
       * @return { boolean } whether layer need to be show on query result list
       * 
       * @since 3.9.1
       */
      showLayer(layer) {
        return (
          layer.show &&                                                      // check if is set show
          (
            this.layerHasFeatures(layer) ||                                  // check if layer has at least one features
            layer.rawdata ||                                                 // check if layer has rawdata
            Array.isArray(layer.infoformats) && layer.infoformats.length > 0 // check if it has info formats (eg. external wms layer)
          )
        )
      },

      /**
       *
       * @param layerId
       * @param type feature or layer
       * @param position
       * @returns {*}
       */
      getLayerCustomComponents(layerId, type = 'feature', position = 'after') {
        return this.state.layerscustomcomponents[layerId]
          && this.state.layerscustomcomponents[layerId][type]
          && this.state.layerscustomcomponents[layerId][type][position]
          || [];
      },
      getLayerField({ layer, feature, fieldName }) {
        const layerField = layer.attributes.find(a => fieldName === a.name);
        return {
          ...layerField,
          label: null, // needed to hide label in query result dom table value content
          value: feature.attributes[fieldName]
        };
      },
      getQueryFields(layer, feature) {
        const fields = [];
        for (const field of layer.formStructure.fields) {
          const _field = { ...field };
          _field.query = true;
          _field.value = feature.attributes[field.name];
          _field.input = {
            type: `${this.getFieldType(_field)}`
          };
          fields.push(_field);
        }
        return fields;
      },
      getColSpan(layer) {
        return this.attributesSubsetLength(layer)+(!this.hasLayerOneFeature(layer)*1);
      },
      addLayerFeaturesToResults(layer) {
        this.$options.service.addLayerFeaturesToResultsAction(layer);
      },
      printAtlas(layer) {
        this.$options.service.printAtlas(layer);
      },
      showLayerDownloadFormats(layer) {
        showDownloadFormats(layer);
      },
      saveLayerResult(layer, type = "csv") {
        downloadFeatures(type, layer, layer.features);
      },
      hasLayerOneFeature(layer) {
        return 1 === layer.features.length;
      },

      /**
       * @param layer
       *
       * @since 3.9.0
       */
      saveFilter(layer) {
        getCatalogLayerById(layer.id).saveFilter();
      },
      async addRemoveFilter(layer) {
        await getCatalogLayerById(layer.id).toggleFilterToken();
      },
      getContainerFromFeatureLayer({ layer, index } = {}) {
        return $(`#${layer.id}_${index} > td`);
      },
      hasOneLayerAndOneFeature(layer) {
        return this.hasLayerOneFeature(layer);
      },
      hasFormStructure(layer) {
        return !!layer.formStructure;
      },
      layerHasFeatures(layer) {
        return Array.isArray(layer.features) && layer.features.length > 0;
      },
      toggleSelection(layer) {
        this.$options.service.toggleSelection(layer);
      },
      extractAttributesFromFirstTabOfFormStructureLayers(layer) {
        const attributes = new Set();
        const traverseStructure = item => {
          if (item.nodes) {
            item.nodes.forEach(node => traverseStructure(node));
          } else {
            let field = layer.formStructure.fields.find(f => item.field_name === f.name);
            if (field) {
              if (this.state.type === 'ows') {
                // clone it to avoid replacing original
                field = {...field};
                field.name = field.name.replace(/ /g, '_');
              }
              attributes.add(field);
            }
          }
        };
        if (layer.formStructure.structure.length) {
          layer.formStructure.structure.forEach(structure => traverseStructure(structure));
        }
        return Array.from(attributes);
      },

      attributesSubset(layer) {
        const attributes = this.hasFormStructure(layer)
          ? this.extractAttributesFromFirstTabOfFormStructureLayers(layer)
          : layer.attributes;
        const _attributes = attributes.filter(attribute => attribute.show && HEADERTYPESFIELD.includes(attribute.type));
        // TODO: find a clever way to handle geocoding results..
        const end = Math.min(/*'__g3w_marker' === layer.id ? 0 :*/ layer.max_preview_fields, attributes.length);
        return _attributes.slice(0, end);
      },
      attributesSubsetLength(layer) {
        return this.attributesSubset(layer).length;
      },
      getLayerFormStructure(layer) {
        //need to clone structure objects in deep and set reactive with Vue.observable
        return layer.formStructure.structure.map(n => Vue.observable(structuredClone(n)));
      },
      getLayerFeatureBox(layer, feature, relation_index) {
        const boxid = this.getBoxId(layer, feature, relation_index);
        if (undefined === this.state.layersFeaturesBoxes[boxid] ) {
          this.state.layersFeaturesBoxes[boxid] = Vue.observable({
            collapsed: true
          });
          this.$watch(
            () => this.state.layersFeaturesBoxes[boxid].collapsed,
            collapsed => {
              const index     = layer.features.findIndex(_feature => feature.id === _feature.id);
              const container = this.getContainerFromFeatureLayer({ layer, index });
              this.$options.service.openCloseFeatureResult({ open:!collapsed, layer, feature, container })
            }
          );
          this.state.layersFeaturesBoxes[boxid].collapsed = layer.features.length > 1;
        }
        return this.state.layersFeaturesBoxes[boxid];
      },

      // to CHECK NOT GOOD
      collapsedFeatureBox(layer, feature, relation_index) {
        const box = this.state.layersFeaturesBoxes[this.getBoxId(layer, feature, relation_index)];
        return box ? box.collapsed : true;
      },

      showFeatureInfo(layer, boxid) {
        const box = this.state.layersFeaturesBoxes[boxid];
        this.$options.service.emit('show-query-feature-info', {
          layer,
          tabs: this.hasFormStructure(layer),
          show: box ? !box.collapsed : false,
        });
      },

      /**
       * @since 3.11.8
       * Show only features that have show true and in case of active filter, only selected 
       */
      showFeature(layer, feature) {
        return this.$options.service.showFeature(layer, feature);
      },
      getBoxId(layer, feature, relation_index) {
        return this.$options.service.getBoxId(layer, feature, relation_index);
      },
      async toggleFeatureBox(layer, feature, relation_index) {
        const boxid = this.getBoxId(layer, feature, relation_index);
        this.state.layersFeaturesBoxes[boxid].collapsed = !this.state.layersFeaturesBoxes[boxid].collapsed;
        await this.$nextTick();
        this.showFeatureInfo(layer, boxid);
      },
      toggleFeatureBoxAndZoom(layer, feature, relation_index) {
        if (!this.hasLayerOneFeature(layer)) { this.toggleFeatureBox(layer, feature, relation_index) }
      },
      async trigger(action,layer,feature, index) {
        if (action.opened && 'none' === $(`#${layer.id}_${index}`).css('display')) {
          this.toggleFeatureBox(layer, feature);
          await this.$nextTick();
        }
        await this.$options.service.trigger(action.id, layer,feature, index, this.getContainerFromFeatureLayer({ layer, index }));
      },
      openLink(link_url) {
        window.open(link_url, '_blank');
      },

      /**
       * @since 3.9.0
       */
       isJSON(field) {
        return !this.isVue(field) && this.isSimple(field) && 'Object' === toRawType(field.value);
      },

      /**
       * @since 3.10.0
       */
      openAttributeTable(layer) {
        getCatalogLayerById(layer.id).openAttributeTable({ perc: 100 });
      },

      /**
       * Highlight all features of layer
       *
       * @param layer
       * @param opts
       *
       * @since 3.11.0
       */
      highLightLayerFeatures(layer, opts = { highlight: true }) {
        if (layer.hasgeometry) {
          this.$options.service.highLightLayerFeatures(layer, opts);
        }
      },

      /**
       * @since 3.11.0
       */
      collapseSidebar(e) {
        const box       = e.target.closest(".box");
        const collapsed = box.classList.contains('collapsed-box');
        box.classList.toggle('collapsed-box');
        box.querySelector(".btn-collapser").classList.toggle('fa-plus', !collapsed);
        box.querySelector(".btn-collapser").classList.add('fa-minus', collapsed);
      },

      /**
       * @param { number } index index of layer
       * @param { number } page  page number
       * @param { number } size  features per page
       */
      async changePage(index, page, size) {
        const { query, layers } = this.state;

        layers[index].loading = true;

        try {
          // set current features count shown by selection 
          if (undefined !== size) {
            query.pagination.current_sizes[index] = size;
          }

          const page_size = query.pagination.current_sizes[index];

          // remove "autofilter" parameter (on first request)
          if (query.autofilter && query.pagination.paginate[index]) {
            query.autofilter = false;
            query.pagination.getData.params.forEach(p => delete p.autofilter);
          }

          // set page size
          if (page_size) {
            query.pagination.getData.params[index].page_size = page_size;
          }

          // get config from getData object
          const { method, params } = query.pagination.getData;
          const layer              = (query.pagination.getData.layers || [])[index];

          // whehter layer has filter
          const has_filtertoken = !!layer.getFilterToken();

          // get layer pagination data
          const data = await layer[method]({ ...params[index], page });
          
          // set response data
          this.$options.service.setQueryResponse(
            { ...data, query },
            { add: false, update: true }
          );

          // set paginate base of change amount of features request changing select value on query result
          query.pagination.paginate[index] = data.count > (data.data || [])[0].features.length;

          // set new number of pages
          query.pagination.pages[index]    = Math.ceil(data.count / page_size);

          // set filter pagination in case of all features are get from pagination
          layers[index].filter.pagination  = layers[index].filter.active && query.pagination.paginate[index];

          // set the current page
          query.pagination.current[index]  = page;

          const page_size_change = layer.state.selection.active || has_filtertoken ;

          // get selection action
          const action = this.state.layersactions[layer.getId()].find(({ id }) => 'selection' === id);

          layers[index].features.forEach((f, i) => {
            if (page_size_change && !f.selection.selected && f.geometry && layer.isGeoLayer()) {
              const fid = layers[index].external ? f.id : (f.attributes[G3W_FID] || f.id);
              layer.addOlSelectionFeature({ id: fid, feature:f }).selected = true;
              layer.includeSelectionFid(fid, false);
            }
            f.selection.selected    = page_size_change;
            action.state.toggled[i] = page_size_change;
          });

          layer.state.filter.active    = page_size_change;
          layer.state.selection.active = page_size_change;

          // zoom to features when layer has geometry
          if (layers[index].hasgeometry) {
            this.$options.service.highLightLayerFeatures(layers[index]);
          }
        } catch(e) {
          console.warn(e);
        }

        layers[index].loading = false;
      },
    },

    watch: {
      async 'state.layers'(layers = []) {
        layers.forEach(layer => {
          if (layer.attributes.length <= layer.max_preview_fields && !layer.hasImageField) {
            layer.expandable = false;
          }
          layer.features.forEach(feature => {
            this.getLayerFeatureBox(layer, feature);
            if (feature.attributes.relations) {
              feature.attributes.relations
                .forEach(relation => {
                  relation.elements
                    .forEach((element, index) => this.state.layersFeaturesBoxes[`${layer.id}_${feature.id}_${relation.name}${index}`] = { collapsed: true });
                })
            }
          })
        });

        // check if is a single result layer and if it has one feature
        if (this.onelayerresult && this.hasLayerOneFeature(layers[0])) {
          const layer   = layers[0];
          const feature = layer.features[0];
          const boxid   = this.getBoxId(layer, feature);
          this.$options.service.onceafter('postRender', () => {
            this.showFeatureInfo(layer, boxid);
          });
        }
        requestAnimationFrame(() => this.$options.service.postRender(this.$el));
        await this.$nextTick();
      },
      onelayerresult(bool) {
        if (bool && !this.state.query.pagination?.paginate?.at(0) && !this.state.layers[0].filter.active) {
          GUI.getService('map').highlightFeatures(this.state.layers[0].features, { duration: Infinity });
        }
      }
    },
    created() {
      //PUT HERE THROTTLED FUNCTION
      this.zoomToLayerFeaturesExtent = throttle(layer => {
        this.$options.service.zoomToLayerFeaturesExtent(layer);
      })
    },
    destroyed() {
      this.$options.service.clear();
    }
  };

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"queryresults-wrapper",attrs:{"id":"search-results"}},[(_vm.info.message)?_c('div',{staticClass:"skin-color",staticStyle:{"font-weight":"bold","margin-bottom":"3px","font-size":"1.1em"}},[(_vm.info.icon)?_c('span',{class:_vm.g3wtemplate.getFontClass(_vm.info.icon)}):_vm._e(),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.info.message)+" ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"queryresults-container"},[(_vm.state.layers.length)?[(_vm.hasLayers)?_c('ul',{staticClass:"queryresults",staticStyle:{"position":"relative"},attrs:{"id":"queryresults"}},[_vm._l((_vm.state.layers),function(layer,index){return _c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLayer(layer)),expression:"showLayer(layer)"}]},[_c('bar-loader',{attrs:{"loading":layer.loading}}),_vm._v(" "),_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header with-border",class:{'mobile': _vm.isMobile()},on:{"mouseover":function($event){$event.stopPropagation();return _vm.highLightLayerFeatures(layer, { highlight: true, duration: Infinity })},"mouseout":function($event){$event.stopPropagation();return _vm.highLightLayerFeatures(layer, { highlight: false })},"click":function($event){$event.stopPropagation();return _vm.collapseSidebar.apply(null, arguments)}}},[_c('div',{staticClass:"box-title query-layer-title",style:({fontSize: _vm.isMobile() && '1em !important'})},[(!layer.external)?_c('span',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:left.create",value:('catalog_items.contextmenu.open_attribute_table'),expression:"'catalog_items.contextmenu.open_attribute_table'",arg:"left",modifiers:{"create":true}}],staticClass:"action-button",on:{"click":function($event){$event.stopPropagation();return _vm.openAttributeTable(layer)}}},[_c('span',{staticClass:"action-button-icon",class:_vm.g3wtemplate.getFontClass('list')})]):_vm._e(),_vm._v("\n                "+_vm._s(layer.title)+"\n                "),(!layer.rawdata)?_c('span',[_vm._v("\n                  ("+_vm._s(_vm.canPaginate(layer)
                      ? (layer.features.length + ((_vm.state.query.pagination.current.at(index) - 1) * _vm.state.query.pagination.getData.params.at(index).page_size)) + ' - ' + _vm.state.query.pagination.counts[index]
                      : layer.features.length)+")\n                ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"box-features-action",on:{"click":function($event){$event.stopPropagation();}}},[_c('infoformats',{attrs:{"layer":layer}}),_vm._v(" "),(layer.features.length > 1)?[(layer.hasgeometry)?_c('span',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:left.create",value:('sdk.mapcontrols.query.actions.zoom_to_features_extent.hint'),expression:"'sdk.mapcontrols.query.actions.zoom_to_features_extent.hint'",arg:"left",modifiers:{"create":true}}],staticClass:"action-button",on:{"click":function($event){$event.stopPropagation();return _vm.zoomToLayerFeaturesExtent(layer)}}},[_c('span',{staticClass:"action-button-icon",class:_vm.g3wtemplate.getFontClass('marker')})]):_vm._e(),_vm._v(" "),(layer.atlas.length)?_c('span',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:left.create",value:('sdk.mapcontrols.query.actions.atlas.hint'),expression:"'sdk.mapcontrols.query.actions.atlas.hint'",arg:"left",modifiers:{"create":true}},{name:"download",rawName:"v-download"}],staticClass:"action-button",on:{"click":function($event){$event.stopPropagation();return _vm.printAtlas(layer)}}},[_c('span',{staticClass:"action-button-icon",class:_vm.g3wtemplate.getFontClass('print')})]):_vm._e(),_vm._v(" "),(_vm.getLayerDownloads(layer.downloads).length > 0)?[_c('span',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:left.create",value:('Downloads'),expression:"'Downloads'",arg:"left",modifiers:{"create":true}},{name:"download",rawName:"v-download"}],staticClass:"action-button",class:{'toggled': layer.downloadformats.active}},[_c('span',{staticClass:"action-button-icon",class:_vm.g3wtemplate.getFontClass('download'),on:{"click":function($event){$event.stopPropagation();return _vm.showLayerDownloadFormats(layer)}}})])]:_vm._e()]:_vm._e(),_vm._v(" "),(layer.external || (layer.source && 'wms' !== layer.source.type && !(_vm.state.query && _vm.state.query.pagination)))?_c('span',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:left.create",value:('sdk.mapcontrols.query.actions.add_features_to_results.hint'),expression:"'sdk.mapcontrols.query.actions.add_features_to_results.hint'",arg:"left",modifiers:{"create":true}}],staticClass:"action-button",class:{'toggled': layer.addfeaturesresults.active},on:{"click":function($event){$event.stopPropagation();return _vm.addLayerFeaturesToResults(layer)}}},[_c('span',{staticClass:"action-button-icon",class:_vm.g3wtemplate.getFontClass('plus-square')})]):_vm._e(),_vm._v(" "),(_vm.canSelect(layer))?_c('span',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:left.create",value:('sdk.mapcontrols.query.actions.add_selection.hint'),expression:"'sdk.mapcontrols.query.actions.add_selection.hint'",arg:"left",modifiers:{"create":true}}],staticClass:"action-button skin-tooltip-left",class:{'toggled': layer.selection.active},on:{"click":function($event){$event.stopPropagation();return _vm.toggleSelection(layer)}}},[_c('span',{staticClass:"action-button-icon",class:_vm.g3wtemplate.getFontClass('success')})]):_vm._e(),_vm._v(" "),(!layer.external && layer.selection.active)?[(!layer.filter.pagination)?_c('span',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:left.create",value:('layer_selection_filter.tools.filter'),expression:"'layer_selection_filter.tools.filter'",arg:"left",modifiers:{"create":true}}],staticClass:"action-button skin-tooltip-left",class:{'toggled': layer.filter.active},on:{"click":function($event){$event.stopPropagation();return _vm.addRemoveFilter(layer)}}},[_c('span',{staticClass:"action-button-icon",class:_vm.g3wtemplate.getFontClass('filter')})]):_vm._e(),_vm._v(" "),(
                      _vm.state.logged
                      && layer.filter.active
                      && (null === layer.filter.current || layer.selection.active)
                    )?_c('span',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:left.create",value:('layer_selection_filter.tools.savefilter'),expression:"'layer_selection_filter.tools.savefilter'",arg:"left",modifiers:{"create":true}}],staticClass:"action-button skin-tooltip-left",on:{"click":function($event){$event.stopPropagation();return _vm.saveFilter(layer)}}},[_c('span',{staticClass:"action-button-icon",class:_vm.g3wtemplate.getFontClass('save')})]):_vm._e()]:_vm._e()],2),_vm._v(" "),_c('button',{staticClass:"btn btn-box-tool",staticStyle:{"pointer-events":"none"}},[_c('i',{staticClass:"btn-collapser skin-color",class:_vm.g3wtemplate.font['minus']})])]),_vm._v(" "),(_vm.state.layeractiontool[layer.id].component)?[_c('div',{staticClass:"g3w-layer-action-tools with-border",class:{'mobile': _vm.isMobile()},staticStyle:{"padding":"5px"}},[_c(_vm.state.layeractiontool[layer.id].component,{tag:"component",attrs:{"layer":layer,"config":_vm.state.layeractiontool[layer.id].config}})],1)]:_vm._e(),_vm._v(" "),_vm._l((_vm.getLayerCustomComponents(layer.id, 'layer', 'before')),function(ref){
                    var component = ref.component;
return _c(component,{tag:"component",attrs:{"layer":layer}})}),_vm._v(" "),(_vm.state.query.pagination && _vm.state.query.pagination.page_sizes[index].length > 1)?_c('div',{directives:[{name:"disabled",rawName:"v-disabled",value:(layer.loading),expression:"layer.loading"}],attrs:{"id":"g3w-queryresults-pagination"}},[_c('select',{staticClass:"form-control",staticStyle:{"width":"auto"},on:{"change":function($event){_vm.changePage(index, 1, Number($event.target.value))}}},_vm._l((_vm.state.query.pagination.page_sizes[index]),function(page){return _c('option',{key:page,domProps:{"value":page}},[_vm._v(_vm._s(page))])}),0),_vm._v(" "),_c('ul',{staticStyle:{"display":"flex","align-items":"center"},attrs:{"disabled":!layer.loading}},[_c('li',[(_vm.state.query.pagination.counts[index] > layer.features.length)?_c('button',{staticClass:"btn fas fa-angle-left",attrs:{"disabled":1 === _vm.state.query.pagination.current[index]},on:{"click":function($event){$event.stopPropagation();return _vm.changePage(index, _vm.state.query.pagination.current[index] - 1)}}}):_vm._e()]),_vm._v(" "),_c('li',[_c('button',{directives:[{name:"disabled",rawName:"v-disabled",value:(layer.features.length === _vm.state.query.pagination.counts[index]),expression:"layer.features.length === state.query.pagination.counts[index]"}],staticClass:"btn",class:{ 'skin-background-color': 1 === _vm.state.query.pagination.current[index] },on:{"click":function($event){$event.stopPropagation();return _vm.changePage(index, 1)}}},[_vm._v("1")])]),_vm._v(" "),(_vm.state.query.pagination.counts[index] > layer.features.length && _vm.state.query.pagination.pages[index] > 4 && _vm.state.query.pagination.current[index] > 2)?_c('li',[_vm._v("…")]):_vm._e(),_vm._v(" "),_c('li',[(_vm.state.query.pagination.pages[index] > 1 && _vm.state.query.pagination.counts[index] > layer.features.length)?_vm._l(((
                      (_vm.state.query.pagination.pages[index] < 4 || _vm.state.query.pagination.current[index] < 3)
                        ? Array.from(Array(_vm.state.query.pagination.pages[index] - 2).keys()).slice(0, 2).map(function (i) { return i + 2; })
                        : (_vm.state.query.pagination.pages[index] - _vm.state.query.pagination.current[index]) > 2
                        ? [_vm.state.query.pagination.current[index], _vm.state.query.pagination.current[index] + 1 ]
                        : [_vm.state.query.pagination.pages[index] - 2, _vm.state.query.pagination.pages[index] - 1 ]
                      )),function(page){return _c('button',{staticClass:"btn",class:{ 'skin-background-color': page === _vm.state.query.pagination.current[index]  },on:{"click":function($event){$event.stopPropagation();return _vm.changePage(index, page)}}},[_vm._v(_vm._s(page)+"\n                    ")])}):_vm._e()],2),_vm._v(" "),(_vm.state.query.pagination.counts[index] > layer.features.length && _vm.state.query.pagination.pages[index] > 4 && (_vm.state.query.pagination.current[index] < _vm.state.query.pagination.pages[index] - 2))?_c('li',[_vm._v("…")]):_vm._e(),_vm._v(" "),_c('li',[(_vm.state.query.pagination.counts[index] > layer.features.length && _vm.state.query.pagination.pages[index] > 1)?_c('button',{staticClass:"btn",class:{ 'skin-background-color': _vm.state.query.pagination.pages[index] === _vm.state.query.pagination.current[index]  },on:{"click":function($event){$event.stopPropagation();return _vm.changePage(index, _vm.state.query.pagination.pages[index])}}},[_vm._v("\n                    "+_vm._s(_vm.state.query.pagination.pages[index])+"\n                  ")]):_vm._e()]),_vm._v(" "),_c('li',[(_vm.state.query.pagination.counts[index] > layer.features.length)?_c('button',{staticClass:"btn fas fa-angle-right",attrs:{"disabled":_vm.state.query.pagination.pages[index] === _vm.state.query.pagination.current[index]},on:{"click":function($event){$event.stopPropagation();return _vm.changePage(index, _vm.state.query.pagination.current[index] + 1)}}}):_vm._e()])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"box-body",class:{'mobile': _vm.isMobile()}},[(layer.rawdata)?[_c('div',{staticClass:"queryresults-text-html",class:{text: layer.infoformat === 'text/plain'},domProps:{"innerHTML":_vm._s(layer.rawdata)}})]:(_vm.hasFormStructure(layer))?[_c('table',{staticClass:"table",class:{'mobile': _vm.isMobile()}},_vm._l((layer.features),function(feature,index){return (_vm.showFeature(layer, feature))?_c('tbody',{key:feature.id},[_c('header-feature-actions-body',{attrs:{"colspan":_vm.getColSpan(layer),"actions":_vm.state.layersactions[layer.id],"layer":layer,"feature":feature,"index":index,"onelayerresult":_vm.onelayerresult,"trigger":_vm.trigger,"toggleFeatureBoxAndZoom":_vm.toggleFeatureBoxAndZoom,"hasLayerOneFeature":_vm.hasLayerOneFeature,"boxLayerFeature":_vm.getLayerFeatureBox(layer, feature),"attributesSubset":_vm.attributesSubset,"getLayerField":_vm.getLayerField}}),_vm._v(" "),_c('tr',{staticClass:"g3w-feature-result-action-tools"},[(_vm.state.currentactiontools[layer.id][index])?[_c('td',{attrs:{"colspan":_vm.getColSpan(layer)}},[_c(_vm.state.currentactiontools[layer.id][index],{tag:"component",attrs:{"colspan":_vm.getColSpan(layer),"layer":layer,"feature":feature,"featureIndex":index,"config":_vm.state.actiontools[_vm.state.currentactiontools[layer.id][index].name][layer.id]}})],1)]:_vm._e()],2),_vm._v(" "),(!_vm.hasLayerOneFeature(layer))?_c('tr',{staticStyle:{"font-weight":"bold","text-align":"center"}},[_vm._l((_vm.attributesSubset(layer)),function(attribute,index){return _c('td',{staticClass:"centered"},[_vm._v("\n                            "+_vm._s(_vm.getLayerFeatureBox(layer, feature).collapsed ? attribute.label : '')+"\n                          ")])}),_vm._v(" "),_c('td',{staticClass:"collapsed",class:{noAttributes: _vm.attributesSubset(layer).length === 0},staticStyle:{"text-align":"end"},on:{"click":function($event){$event.stopPropagation();return _vm.toggleFeatureBoxAndZoom(layer,feature)}}},[_c('span',{staticClass:"fa link morelink skin-color",class:_vm.g3wtemplate.font[_vm.getLayerFeatureBox(layer, feature).collapsed  ? 'plus': 'minus']})])],2):_vm._e(),_vm._v(" "),(!_vm.hasLayerOneFeature(layer) && _vm.getLayerFeatureBox(layer, feature).collapsed)?_c('header-feature-body',{attrs:{"actions":_vm.state.layersactions[layer.id],"layer":layer,"feature":feature,"index":index,"onelayerresult":_vm.onelayerresult,"trigger":_vm.trigger,"toggleFeatureBoxAndZoom":_vm.toggleFeatureBoxAndZoom,"hasLayerOneFeature":_vm.hasLayerOneFeature,"boxLayerFeature":_vm.getLayerFeatureBox(layer, feature),"attributesSubset":_vm.attributesSubset,"getLayerField":_vm.getLayerField}}):_vm._e(),_vm._v(" "),_vm._l((_vm.getLayerCustomComponents(layer.id, 'feature', 'before')),function(ref){
                      var component = ref.component;
return _c('tr',[_c('td',{attrs:{"colspan":_vm.getColSpan(layer)}},[_c(component,{tag:"component",attrs:{"layer":layer,"feature":feature}})],1)])}),_vm._v(" "),_c('tr',{directives:[{name:"show",rawName:"v-show",value:(!_vm.collapsedFeatureBox(layer,feature) || _vm.hasOneLayerAndOneFeature(layer)),expression:"!collapsedFeatureBox(layer,feature) || hasOneLayerAndOneFeature(layer)"}],staticClass:"featurebox-body",attrs:{"id":((layer.id) + "_" + index)}},[_c('td',{attrs:{"colspan":_vm.getColSpan(layer),"feature-html-content":((layer.id) + "_" + index)}},[_c('tabs',{attrs:{"fields":_vm.getQueryFields(layer, feature),"layerid":layer.id,"feature":feature,"tabs":_vm.getLayerFormStructure(layer)}})],1)]),_vm._v(" "),_vm._l((_vm.getLayerCustomComponents(layer.id, 'feature', 'after')),function(ref){
                      var component = ref.component;
return _c('tr',[_c('td',{attrs:{"colspan":_vm.getColSpan(layer)}},[_c(component,{tag:"component",attrs:{"layer":layer,"feature":feature}})],1)])})],2):_vm._e()}),0)]:[_c('table',{staticClass:"table",class:{'mobile': _vm.isMobile()}},_vm._l((layer.features),function(feature,index){return (_vm.showFeature(layer, feature))?_c('tbody',{key:feature.id},[_c('header-feature-actions-body',{attrs:{"colspan":_vm.getColSpan(layer),"actions":_vm.state.layersactions[layer.id],"layer":layer,"feature":feature,"index":index,"onelayerresult":_vm.onelayerresult,"trigger":_vm.trigger,"toggleFeatureBoxAndZoom":_vm.toggleFeatureBoxAndZoom,"hasLayerOneFeature":_vm.hasLayerOneFeature,"boxLayerFeature":_vm.getLayerFeatureBox(layer, feature),"attributesSubset":_vm.attributesSubset,"getLayerField":_vm.getLayerField}}),_vm._v(" "),_c('tr',{staticClass:"g3w-feature-result-action-tools"},[(_vm.state.currentactiontools[layer.id][index])?[_c('td',{attrs:{"colspan":_vm.getColSpan(layer)}},[_c(_vm.state.currentactiontools[layer.id][index],{tag:"component",attrs:{"colspan":_vm.getColSpan(layer),"layer":layer,"feature":feature,"featureIndex":index,"config":_vm.state.actiontools[_vm.state.currentactiontools[layer.id][index].name][layer.id]}})],1)]:_vm._e()],2),_vm._v(" "),(!_vm.hasLayerOneFeature(layer))?_c('tr',{staticStyle:{"font-weight":"bold","text-align":"center"}},[_vm._l((_vm.attributesSubset(layer)),function(attribute,index){return _c('td',{staticClass:"centered"},[_vm._v("\n                        "+_vm._s(_vm.getLayerFeatureBox(layer, feature).collapsed ? attribute.label : '')+"\n                      ")])}),_vm._v(" "),_c('td',{staticClass:"collapsed",class:{ noAttributes: 0 === _vm.attributesSubset(layer).length },staticStyle:{"text-align":"end"},on:{"click":function($event){$event.stopPropagation();return _vm.toggleFeatureBoxAndZoom(layer,feature)}}},[_c('span',{staticClass:"fa link morelink skin-color",class:_vm.g3wtemplate.font[_vm.getLayerFeatureBox(layer, feature).collapsed ? 'plus': 'minus']})])],2):_vm._e(),_vm._v(" "),(!_vm.hasLayerOneFeature(layer) && _vm.getLayerFeatureBox(layer, feature).collapsed)?_c('header-feature-body',{attrs:{"actions":_vm.state.layersactions[layer.id],"layer":layer,"feature":feature,"index":index,"onelayerresult":_vm.onelayerresult,"trigger":_vm.trigger,"toggleFeatureBoxAndZoom":_vm.toggleFeatureBoxAndZoom,"hasLayerOneFeature":_vm.hasLayerOneFeature,"boxLayerFeature":_vm.getLayerFeatureBox(layer, feature),"attributesSubset":_vm.attributesSubset,"getLayerField":_vm.getLayerField}}):_vm._e(),_vm._v(" "),_vm._l((_vm.getLayerCustomComponents(layer.id, 'feature', 'before')),function(ref){
                      var component = ref.component;
return _c('tr',[_c('td',{attrs:{"colspan":_vm.getColSpan(layer)}},[_c(component,{tag:"component",staticClass:"box-body",attrs:{"layer":layer,"feature":feature}})],1)])}),_vm._v(" "),_c('tr',{directives:[{name:"show",rawName:"v-show",value:(!_vm.collapsedFeatureBox(layer,feature) || _vm.hasOneLayerAndOneFeature(layer)),expression:"!collapsedFeatureBox(layer,feature) || hasOneLayerAndOneFeature(layer)"}],staticClass:"featurebox-body",attrs:{"id":((layer.id) + "_" + index)}},[_c('td',{attrs:{"colspan":_vm.getColSpan(layer),"feature-html-content":((layer.id) + "_" + index)}},[_c('table',{staticClass:"feature_attributes"},[_vm._l((layer.attributes.filter(function (attribute) { return attribute.show; })),function(attribute){return [(_vm.isJSON(_vm.getLayerField({layer: layer, feature: feature, fieldName: attribute.name})))?[_vm._l((_vm.getLayerField({layer: layer, feature: feature, fieldName: attribute.name}).value),function(v,k){
                      var _obj;
return _vm._l((('object' === typeof v ? v : ( _obj = {}, _obj[k] = v, _obj ))),function(v2,k2){return _c('tr',{staticStyle:{"padding-top":"10px","padding-bottom":"10px"}},[_c('td',{staticClass:"attr-label"},[_vm._v(_vm._s(attribute.label)+"."),(('object' === typeof v))?[_vm._v(_vm._s(k)+".")]:_vm._e(),_vm._v(_vm._s(k2))],2),_vm._v(" "),_c('td',{staticClass:"attr-value"},[_vm._v(_vm._s(v2))])])})})]:_c('tr',[_c('td',{staticClass:"attr-label"},[_vm._v(_vm._s(attribute.label))]),_vm._v(" "),_c('td',{staticClass:"attr-value",attrs:{"attribute":attribute.name}},[_c('table-attribute-field-value',{attrs:{"feature":feature,"field":_vm.getLayerField({layer: layer, feature: feature, fieldName: attribute.name})}})],1)])]})],2)])]),_vm._v(" "),_vm._l((_vm.getLayerCustomComponents(layer.id, 'feature', 'after')),function(ref){
                      var component = ref.component;
return _c('tr',[_c('td',{attrs:{"colspan":"getColSpan(layer)"}},[_c(component,{tag:"component",staticClass:"box-body",attrs:{"layer":layer,"feature":feature}})],1)])})],2):_vm._e()}),0)]],2),_vm._v(" "),_vm._l((_vm.getLayerCustomComponents(layer.id, 'layer', 'after')),function(ref){
                      var component = ref.component;
return _c('div',{staticClass:"box-body",class:{'mobile': _vm.isMobile()}},[_c(component,{tag:"component",attrs:{"layer":layer}})],1)})],2)],1)}),_vm._v(" "),_vm._l((_vm.state.components),function(component){return _c('li',[_c(component,{tag:"component",on:{"showresults":function($event){return _vm.showResults()}}})],1)})],2):_vm._e()]:[(_vm.state.changed)?_c('div',{staticClass:"query-results-not-found"},[_c('h4',{directives:[{name:"t",rawName:"v-t",value:('info.no_results'),expression:"'info.no_results'"}],staticClass:"skin-color",staticStyle:{"font-weight":"bold","text-align":"center"}})]):_vm._e()]],2),_vm._v(" "),(_vm.state.query)?_c('div',{staticStyle:{"visibility":"hidden","position":"sticky","bottom":"-8px","background":"#eee","padding":"8px 0","display":"flex","gap":"1em"}},[_c('label',{staticStyle:{"margin-top":"5px"}},[_vm._v(_vm._s(_vm.$t('query_filter')))]),_vm._v(" "),_c('select',{staticStyle:{"flex":"1"}},[_vm._l((_vm.queryableLayers),function(layer){return _c('option',{domProps:{"selected":layer === _vm.selectedLayer}},[_vm._v(_vm._s(layer.getName()))])}),_vm._v(" "),_c('option',{domProps:{"selected":!_vm.selectedLayer}},[_vm._v(_vm._s(_vm.$t('sdk.mapcontrols.queryby.all')))])],2)]):_vm._e()])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-38f64025_0", { source: ".feature_attributes tr[data-v-38f64025]{line-height:1.8em}.featurebox-body+tr[data-v-38f64025]{border-top:2px groove #000}#g3w-queryresults-pagination[data-v-38f64025]{display:flex;justify-content:space-between;align-items:center;margin-top:15px;flex-wrap:wrap;margin-left:10px}#g3w-queryresults-pagination>ul>li>*[data-v-38f64025]{background-color:transparent;margin:2px;font-weight:700;font-size:.8em}", map: undefined, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-38f64025"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "QueryResults.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (true && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__